import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../auth';

export function StrategiesPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const { data, isLoading, error } = useQuery({ queryKey: ['strategies'], queryFn: api.strategies });

  return (
    <>
      <div className="page-header">
        <h2>Стратегии репрайсера</h2>
        {isAdmin && <Link to="/strategies/new" className="btn primary">+ Создать стратегию</Link>}
      </div>

      {isLoading && <div className="card">Загрузка…</div>}
      {error && <div className="card" style={{ color: 'var(--red)' }}>{String((error as Error).message)}</div>}

      {data && (
        <table className="products">
          <thead>
            <tr>
              <th>Название</th>
              <th>Cron</th>
              <th>Товаров</th>
              <th>Запусков</th>
              <th>Статус</th>
              <th>Создана</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.items.length === 0 && (
              <tr><td colSpan={7} className="muted" style={{ textAlign: 'center', padding: 24 }}>
                Стратегий нет. Создайте первую.
              </td></tr>
            )}
            {data.items.map((s) => (
              <tr key={s.id}>
                <td><Link to={`/strategies/${s.id}`}><strong>{s.name}</strong></Link></td>
                <td className="muted">{s.scheduleCron}</td>
                <td className="num">{s._count.products}</td>
                <td className="num">{s._count.jobs}</td>
                <td>{s.enabled ? <span style={{ color: 'var(--green)' }}>● Активна</span> : <span className="muted">○ Выкл</span>}</td>
                <td className="muted">{new Date(s.createdAt).toLocaleDateString('ru-RU')}</td>
                <td><Link to={`/strategies/${s.id}/products`} className="btn">Товары</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
